import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { AuthProvider } from "context/AuthProvider";
import Demande from "demande/Demande";
import RequireAuth from "views/examples/RequireAuth";
import Unauthorized from "views/examples/Unauthorized";
import ProtectedRoute from "views/examples/ProtectedRoute";
import DemandeHeader from "components/Headers/DemandeHeader";
import LandingPage from "components/landingPage";
import Profile from "views/examples/Profile";
import SystemAdminDashboard from "views/admin/SystemAdminDashboard";
import AddPlan from "views/admin/AddPlan";
import PlansList from "views/admin/PlansList";
import EditPlan from "views/admin/EditPlan";
import PlanDetail from "views/admin/PlanDetail";
import TenantLayout from "layouts/TenantAdminLayout";
import AddTenant from "views/tenantAdmin/AddTenant";
import EditTenant from "views/tenantAdmin/EditTenant";
import PaymentSuccess from "views/tenantAdmin/PaymentSuccess";
import PaymentCancel from "views/tenantAdmin/PaymentCancel";
import BranchForm from "views/tenantAdmin/BranchForm";
import BranchDetail from "views/tenantAdmin/BranchDetail";
import AuditLogs from "views/admin/AuditLogs";
import CategoriesList from "views/tenantAdmin/CategoriesList";
import CategoryDetail from "views/tenantAdmin/CategoryDetail";
import InvoiceScanner from "views/stockManager/InvoiceScanner";
import BranchAdminLayout from "layouts/BranchAdminLayout";
import BranchUsersPage from "views/branchAdmin/BranchUsersPage";
import StockManagerLayout from "layouts/StockManagerLayout";
import AccountantLayout from "layouts/AccountantLayout";
import AccountantDashboard from "views/accountant/AccountantDashboard";
import JournalEntries from "views/accountant/JournalEntries";
import TrialBalance from "views/accountant/TrialBalance";
import ProfitLoss from "views/accountant/ProfitLoss";
import POS from "views/cashier/Pos";
import { RegisterProvider } from "views/cashier/RegisterContext";
import WithdrawalApprovalPage from "views/branchAdmin/WithdrawalApprovalPage";
import RHLayout from "layouts/RhLayout";
import AttendanceKiosk from "views/examples/AttendanceKiosk";
import SubscriptionsList from "views/admin/SubscriptionsList";
import CashierDashboard from "views/cashier/CashierDashboard";
import CashierLayout from "layouts/CashierLayou";
import { Switch, Redirect } from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>
    <RegisterProvider>
      <BrowserRouter>
        <Routes>
          {/* Public / unauthenticated routes */}
          <Route
            path="/auth/*"
            element={
              <ProtectedRoute>
                <AuthLayout />
              </ProtectedRoute>
            }
          />

          {/* Admin routes (protected, only SYSTEM_ADMIN) */}
          <Route
            element={
              <RequireAuth allowedRoles={["SYSTEM_ADMIN"]} />
            }
          >
            <Route path="/admin/*" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/index" replace />} />
              <Route path="addDemande" element={<DemandeHeader />} />
              <Route path="add-plan" element={<AddPlan />} />
              <Route path="list-plan" element={<PlansList />} />
              <Route path="edit-plan/:id" element={<EditPlan />} />
              <Route path="logs" element={<AuditLogs />} />
              <Route path="Profile" element={<Profile />} />
              <Route path="subscriptions" element={<SubscriptionsList />} />
              {/* other admin pages */}
            </Route>
          </Route>

          {/* Tenant routes (protected, TENANT_ADMIN) — add similarly */}
          <Route
            element={
              <RequireAuth allowedRoles={["TENANT_ADMIN"]} />
            }
          >
            <Route path="/tenant/*" element={<TenantLayout />} >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="edit-tenant" element={<EditTenant />} />
              <Route path="payment/success" element={<PaymentSuccess />} />
              <Route path="payment/cancel" element={<PaymentCancel />} />
              <Route path="add-tenant" element={<AddTenant />} />
              <Route path="branches/add" element={<BranchForm />} />
              <Route path="categories" element={<CategoriesList />} />
              <Route path="categories/:id" element={<CategoryDetail />} />
              <Route path="Profile" element={<Profile />} />
              <Route path="branches/edit/:id" element={<BranchForm />} />
              <Route path="branches/:id" element={<BranchDetail />} />
              {/* <Route path="plans" element={<PlanSelection />} /> */}
              {/* ... */}
            </Route>
          </Route>


          {/* Tenant routes (protected, BRANCH_ADMIN) — add similarly */}
          <Route
            element={
              <RequireAuth allowedRoles={["BRANCH_ADMIN"]} />
            }
          >
            <Route path="/branch/*" element={<BranchAdminLayout />} >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="users" element={<BranchUsersPage />} />
              <Route path="Profile" element={<Profile />} />
              <Route path="withdrawals" element={<WithdrawalApprovalPage />} />
            </Route>
          </Route>


          {/* Tenant routes (protected, STOCK_MANAGER) — add similarly */}
          <Route
            element={
              <RequireAuth allowedRoles={["STOCK_MANAGER"]} />
            }
          >
            <Route path="/stock/*" element={<StockManagerLayout />} >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="invoices/scan" element={<InvoiceScanner />} />
              <Route path="Profile" element={<Profile />} />
            </Route>
          </Route>
          {/* Tenant routes (protected, RH) — add similarly */}
          <Route
            element={
              <RequireAuth allowedRoles={["RH"]} />
            }
          >
            <Route path="/rh/*" element={<RHLayout />} >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="Profile" element={<Profile />} />
            </Route>
          </Route>

          <Route element={<RequireAuth allowedRoles={["ACCOUNTANT"]} />}>
            <Route path="/accountant/*" element={<AccountantLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<AccountantDashboard />} />
              <Route path="journal" element={<JournalEntries />} />
              <Route path="trial-balance" element={<TrialBalance />} />
              <Route path="profit-loss" element={<ProfitLoss />} />
            </Route>
          </Route>



          <Route element={<RequireAuth allowedRoles={["CASHIER"]} />}>
            <Route path="/cashier/*" element={<CashierLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<CashierDashboard />} />


            </Route>
          </Route>


          <Route path="/unauthorized" element={<Unauthorized />} />

          <Route path="pos" element={<POS />} />

          <Route
            path="/"
            element={<Navigate to="/home" replace />}
          />

          <Route path="/home" element={<LandingPage />} />
          <Route path="kiosk" element={<AttendanceKiosk />} />

          <Route path="/detail-plan/:planId" element={<PlanDetail />} />



          {/* Catch all — redirect to login */}
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </BrowserRouter>
    </RegisterProvider>
  </AuthProvider>
);